//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {parseTime} from '@/util/index.js'

export default {
    data(){
        return{
            searchTime:[],
            // 图片路径
            imgUrl:'https://hfb.oss-cn-hangzhou.aliyuncs.com/',
            listData:[],
            loading: false,
            page:1,// 列表页数
            total:'', // 全部个数
            finished: false, // 是否全部加载完成
            refreshing: false, // 加载状态
            outputInfo:{ // 其他信息
                approval_count:0,
                total:0,
                wage:0,
                submit_num:0,
                good_num:0,
                defective_num:0,
                reject_ratio:0,
            }, 
            // 头部
            tabValue:-1,
            option:[
                { text: '全部', value: -1 },
                { text: '未审批', value: 0 },
                { text: '已审批', value: 1 },
            ],
            // 排序 true升序 false降序
            sort_type:true,
            // 时间选择
            show_time:false,
            time_type:'',
            show_date:false,
            data_type:'',
            startTime:'',
            endTime:'',
            timeTitle:'选择时间',
            actvied_t:'',
            actived_i:'',
            minDate: new Date(2018, 0, 1),
            maxDate: new Date(2030, 10, 1),
            currentDate: new Date(),
            // 员工选择
            show_employees:false,
            searchUser:'',
            allRadio:false,
            checkedList:[],
            userList:[],
            // 多选
            isMultiSelect:false,
            
            // 权限
            permissions:false,
        }
    },
    mounted(){
        let role = sessionStorage.getItem('role')
        if(role == 1){  //系统管理员
            this.permissions = true
        }else if(role == 2){  // 管理员
            this.permissions = true
        }else{  // 生产人员
            this.permissions = false
        }
    },
    methods:{
        onLoad() {
            // 异步更新数据
            if (this.refreshing) {
              this.listData = [];
              this.page = 1
              this.refreshing = false;
            }

            let approval_type = ''
            if(this.tabValue != -1){
                approval_type = this.tabValue
            }
            let data = {
                approval_type,
                page:this.page,
                create_time:this.searchTime,
                personnel_id:this.checkedList,
                orders:this.sort_type ? 1 : 2,
            }
            this.$post('/app/Order/getOutputList',data).then(res => {
              this.page++
              this.total = res.total

              this.outputInfo.approval_count = res.approval_count
              this.outputInfo.total = res.total
              this.outputInfo.wage = res.wage
              this.outputInfo.submit_num = res.submit_num
              this.outputInfo.good_num = res.good_num
              this.outputInfo.defective_num = res.defective_num
              this.outputInfo.reject_ratio = ((res.defective_num / res.submit_num) * 100).toFixed(2)

              for (let i = 0; i < res.data.length; i++) {
                res.data[i].isActived = false
                res.data[i].scheduled_time = parseTime(res.data[i].scheduled_start_time,'{y}-{m}-{d}') + '~' + parseTime(res.data[i].scheduled_end_time,'{y}-{m}-{d}')
                res.data[i].time = parseTime(res.data[i].start_time) + '~' + parseTime(res.data[i].end_time)
                if(res.data[i].output_time == 0){
                    res.data[i].output_time_text = '- - - -'
                }else{
                    res.data[i].output_time_text = parseTime(res.data[i].output_time)
                }

                this.listData.push(res.data[i]);
              }

              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.listData.length >= this.total) {
                this.finished = true;
              }

              console.log(this.listData);
            })
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.onLoad();
        },

        // 状态切换
        tabChange(value){
            this.refreshing = true
            this.onRefresh()
        },

        // 点击  未多选进入详情  多选批量审批
        clickItem(item){
            if(this.isMultiSelect){ //多选
                item.isActived = !item.isActived
            }else{
               this.toDetails(item)
            }
        },
        // 详细
        toDetails(item){  
            if(item.approval_type != 0){  // 已审批不可修改
                return
            }  
            let role_id = sessionStorage.getItem('role')
            let user_id = JSON.parse( sessionStorage.getItem('userInfo')).id
            if(role_id != 1 && role_id != 2 && user_id != item.personnel_id){
                console.log('无修改权限');
                return // 无修改权限
            }else{
                let id = item.id
                this.$router.push({
                    path:'/SignOnDetails',
                    query:{id:id}
                })
            }
            
        },
        // 批量审核
        batchApproval(){
            let id = []
            this.listData.forEach(item => {
                if(item.isActived){
                    id.push(item.id)
                }
            })
            this.$post('/app/order/setApproval',{id}).then(res => {
                this.$toast.success('审批成功!');
                this.isMultiSelect = false
                this.refreshing = true
                this.onRefresh()
            })
        },
 
        // 审核是否 1 审核 0 取消审核
        onAudit(i,item){
            let data = {
                add_type:2,
                id:item.id,
                approval_type:i
            }
            this.$dialog.confirm({
                title: '审批',
                message: '是否修改审批状态',
                })
                .then(() => {
                    this.$post('/app/order/setOutput',data).then(res => {
                        this.$toast.success('操作成功!');
                        this.refreshing = true
                        this.onRefresh()
                    })
                })
                .catch(() => {
                    // on cancel
                });
            
        },

        // 去报工
        toWork(){

        },

        // 时间选择
        onTime(){
            this.show_time = true
        },
        onTimeActived(i){
            if(this.time_type == i){
                this.time_type = ''
            }else{
                this.time_type = i
            }
        },
        onShowTime(i){
            this.data_type = i
            this.show_date = true
        },
        confirm(value){
            const i = this.data_type  // 1开始 2结束
            if(i == 1){
                this.startTime = parseTime(value)
            }else{
                this.endTime = parseTime(value)
            }
            this.show_date = false
        },
        cancel(){
            this.show_date = false
        },
        onTimeSave(){
            let now = new Date(); //当前日期 
            let nowDayOfWeek = now.getDay(); //今天本周的第几天 
            let nowDay = now.getDate(); //当前日 
            let nowMonth = now.getMonth(); //当前月 
            let nowYear = now.getFullYear(); //当前年 
            if(this.time_type){
                switch (this.time_type) {
                    case 1:  //今天
                        this.searchTime[0] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                        this.searchTime[1] = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000).getTime() / 1000;
                        break;
                    case 2:  //昨天
                        this.searchTime[0] = new Date(new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000).getTime() / 1000
                        this.searchTime[1] = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
                        break;
                    case 3:  //本周
                        this.searchTime[0] = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek).getTime() /1000
                        this.searchTime[1] = new Date(nowYear, nowMonth, nowDay + 6 - nowDayOfWeek).getTime() /1000
                        break;
                    case 4:  //本月
                        this.searchTime[0] = new Date(nowYear, nowMonth, 1).getTime() /1000
                        this.searchTime[1] = new Date(nowYear, nowMonth + 1, 0).getTime() /1000
                        break;
                    case 5:  //自定义
                        this.searchTime[0] = this.$SET_DATE(this.startTime).getTime() /1000
                        this.searchTime[1] = this.$SET_DATE(this.endTime).getTime() /1000
                        break;
                    default:
                        break;
                }
            }else{
                this.searchTime = []
            }
            this.show_time = false
            this.refreshing = true
            this.onRefresh()  
        },

        // 员工选择
        onUser(){
            this.onSearchUser()
            this.show_employees =  true
        },
        onEmployeesSave(){
            this.refreshing = true
            this.onRefresh()  
            this.show_employees = false
        },
        // 搜索员工
        onSearchUser(){
            let data = {
                name:this.searchUser,
                status:1,
            }
            this.$post('/app/user/getUserSelect',data).then(res => {
                this.userList = res
            })
        },
        // 全选员工按钮
        AllCheckbox(){
            this.checkedList = []
            if(this.allRadio){
                this.userList.forEach(item => {
                    this.checkedList.push(item.id)
                })
            }
        },

        // 多选审核
        onMultiSelect(){
            this.isMultiSelect = !this.isMultiSelect
        },
        

        // 排序
        onSort(){
            this.sort_type = !this.sort_type
            this.refreshing = true
            this.onRefresh()  
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/home/three.vue